module.exports = __webpack_public_path__ + "static/media/model7.ab3c08a6.glb";